// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let React = require("react");
let ReactSelect = require("../../reason/bindings/ReactSelect.bs.js");
let Stdlib_Null = require("@rescript/runtime/lib/js/Stdlib_Null.js");
let ReactSelect$1 = require("react-select").default;
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Async = require("react-select/async").default;
let AsyncCreatable = require("react-select/async-creatable").default;

let indicatorStyle = {
  color: "var(--color-silver-sand)",
  padding: "5px 8px",
  ":hover": {
    color: "var(--color-dove-gray)"
  }
};

function borderColor(state, activeBorderColor, inActiveBorderColor, hoverBorderColor) {
  return {
    borderColor: state.menuIsOpen || state.isFocused ? activeBorderColor : inActiveBorderColor,
    ":hover": state.menuIsOpen ? ({
        borderColor: activeBorderColor
      }) : ({
        borderColor: hoverBorderColor
      })
  };
}

function defaultBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-alto)", "var(--color-silver)");
}

function errorBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-tan-error-500)", "var(--color-tan-error-500)");
}

function okBorderColor(state) {
  return borderColor(state, "var(--color-tan-focused-border)", "var(--color-tan-success)", "var(--color-tan-success)");
}

let defaultStyles_option = (provided, state) => ReactSelect.Styles.combineManyStyles([
  provided,
  state.isFocused ? ({
      backgroundColor: "var(--color-tan-blue-500)",
      color: "var(--color-white)"
    }) : ({}),
  state.isSelected ? ({
      backgroundColor: "rgba(0,126,255,.04)",
      color: "#333"
    }) : ({})
]);

let defaultStyles_menu = (provided, state) => ReactSelect.Styles.combineManyStyles([
  provided,
  defaultBorderColor(state),
  {
    backgroundColor: "var(--color-white)",
    borderRadius: "0",
    marginTop: "0",
    zIndex: "6"
  }
]);

let defaultStyles_control = (provided, state) => ReactSelect.Styles.combineManyStyles([
  provided,
  defaultBorderColor(state),
  {
    backgroundColor: "var(--color-white)",
    borderRadius: "0.125rem",
    boxShadow: "none",
    display: "flex",
    flexWrap: "wrap",
    minHeight: "36px"
  }
]);

let defaultStyles_input = (provided, param) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    display: "flex",
    ":hover": {
      cursor: "text"
    }
  }
]);

let defaultStyles_placeholder = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    color: "var(--color-gray)",
    overflow: "hidden",
    pointerEvents: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%"
  }
]);

let defaultStyles_multiValue = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    backgroundColor: "var(--color-tan-blue-500)",
    color: "var(--color-white)",
    padding: "2px"
  }
]);

let defaultStyles_multiValueLabel = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    color: "var(--color-white)",
    fontSize: "14px"
  }
]);

let defaultStyles_multiValueRemove = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    ":hover": {
      backgroundColor: "var(--color-white)",
      color: "var(--color-tan-blue-500)"
    }
  }
]);

let defaultStyles_groupHeading = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    backgroundColor: "var(--color-gallery)",
    color: "var(--color-jumbo)",
    fontSize: "14px",
    margin: "0",
    padding: "10px"
  }
]);

let defaultStyles_clearIndicator = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  indicatorStyle
]);

let defaultStyles_dropdownIndicator = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  indicatorStyle
]);

let defaultStyles_valueContainer = (provided, _state) => ReactSelect.Styles.combineManyStyles([
  provided,
  {
    padding: "0px 8px"
  }
]);

let defaultStyles = {
  option: defaultStyles_option,
  menu: defaultStyles_menu,
  control: defaultStyles_control,
  input: defaultStyles_input,
  placeholder: defaultStyles_placeholder,
  multiValue: defaultStyles_multiValue,
  multiValueLabel: defaultStyles_multiValueLabel,
  multiValueRemove: defaultStyles_multiValueRemove,
  groupHeading: defaultStyles_groupHeading,
  clearIndicator: defaultStyles_clearIndicator,
  dropdownIndicator: defaultStyles_dropdownIndicator,
  valueContainer: defaultStyles_valueContainer
};

let newrecord = {...defaultStyles};

newrecord.control = (provided, state) => ReactSelect.Styles.combineManyStyles([
  Stdlib_Option.getOr(Stdlib_Option.map(defaultStyles_control, c => c(provided, state)), {}),
  errorBorderColor(state)
]);

let newrecord$1 = {...defaultStyles};

newrecord$1.control = (provided, state) => ReactSelect.Styles.combineManyStyles([
  Stdlib_Option.getOr(Stdlib_Option.map(defaultStyles_control, c => c(provided, state)), {}),
  okBorderColor(state)
]);

let Styles = {
  indicatorStyle: indicatorStyle,
  borderColor: borderColor,
  defaultBorderColor: defaultBorderColor,
  errorBorderColor: errorBorderColor,
  okBorderColor: okBorderColor,
  defaultStyles: defaultStyles,
  errorStyles: newrecord,
  okStyles: newrecord$1
};

function ref(externalRef, selectRef) {
  return domRef => {
    let r = Stdlib_Option.map((domRef == null) ? undefined : Primitive_option.some(domRef), prim => prim);
    Utils.React.setCurrentRef(selectRef, r);
    if (externalRef !== undefined) {
      Utils.React.setCurrentRef(externalRef, r);
    }
  };
}

let SelectRef = {
  ref: ref
};

let Types = {};

function noOptionsMessage(noOptionsMessage$1) {
  return v => {
    let v$1 = noOptionsMessage$1(v.inputValue);
    if (v$1 !== undefined) {
      return v$1;
    } else {
      return null;
    }
  };
}

function statusToStyles(status) {
  switch (status) {
    case "Neutral" :
      return defaultStyles;
    case "Success" :
      return newrecord$1;
    case "Failure" :
      return newrecord;
  }
}

let Helpers = {
  noOptionsMessage: noOptionsMessage,
  statusToStyles: statusToStyles
};

function useCommonProps(input) {
  return {
    getOptionLabel: React.useCallback(opt => input.getOptionLabel(ReactSelect.Options.unwrapOption(opt)), [input.getOptionLabel]),
    getOptionValue: React.useCallback(opt => input.getOptionValue(ReactSelect.Options.unwrapOption(opt)), [input.getOptionValue]),
    formatOptionLabel: React.useCallback(Stdlib_Option.map(input.formatOptionLabel, formatOptionLabel => ((opt, context) => formatOptionLabel(ReactSelect.Options.unwrapOption(opt), context))), [input.formatOptionLabel])
  };
}

function useOptions(input) {
  return React.useMemo(() => Stdlib_Option.map(input, options => options.map(ReactSelect.Options.wrapOption)), [input]);
}

function useLoadOptions(input) {
  return React.useCallback(string => input(string).then(options => options.map(ReactSelect.Options.wrapOption)), [input]);
}

function useLoadOptionsGroup(input) {
  return React.useCallback(string => input(string).then(options => options.map(group => ({
    label: group.label,
    options: group.options.map(ReactSelect.Options.wrapOption)
  }))), [input]);
}

let Common = {
  useCommonProps: useCommonProps,
  useOptions: useOptions,
  useLoadOptions: useLoadOptions,
  useLoadOptionsGroup: useLoadOptionsGroup
};

function useCreatableProps(input) {
  return {
    getNewOptionData: React.useCallback(Stdlib_Option.map(input.getNewOptionData, getNewOptionData => (opt => ReactSelect.Options.wrapOption(getNewOptionData(opt)))), [input.getNewOptionData])
  };
}

let Creatable = {
  useCreatableProps: useCreatableProps
};

function useSingleProps(input) {
  return {
    value: React.useMemo(() => Stdlib_Null.fromOption(Stdlib_Option.map(input.value, ReactSelect.Options.wrapOption)), [input.value]),
    onChange: React.useCallback(Stdlib_Option.map(input.onChange, onChange => (value => onChange(Primitive_option.fromNull(Stdlib_Null.map(value, ReactSelect.Options.unwrapOption))))), [input.onChange])
  };
}

let Single = {
  useSingleProps: useSingleProps
};

function useMultiProps(input) {
  return {
    value: React.useMemo(() => input.value.map(ReactSelect.Options.wrapOption), [input.value]),
    onChange: React.useCallback(Stdlib_Option.map(input.onChange, onChange => (value => onChange(value.map(ReactSelect.Options.unwrapOption)))), [input.onChange])
  };
}

let Multi = {
  useMultiProps: useMultiProps
};

let OptionsHelpers = {
  Common: Common,
  Creatable: Creatable,
  Single: Single,
  Multi: Multi
};

function AutocompleteV5$Select$Single(props) {
  let __status = props.status;
  let status = __status !== undefined ? __status : "Neutral";
  let selectRef = React.useRef(undefined);
  let match = useCommonProps({
    getOptionLabel: props.getOptionLabel,
    getOptionValue: props.getOptionValue,
    formatOptionLabel: props.formatOptionLabel
  });
  let match$1 = useSingleProps({
    value: props.value,
    onChange: props.onChange
  });
  let options = useOptions(props.options);
  return JsxRuntime.jsx(ReactSelect$1, {
    classNamePrefix: "autocomplete",
    controlShouldRenderValue: true,
    formatOptionLabel: match.formatOptionLabel,
    getOptionLabel: match.getOptionLabel,
    getOptionValue: match.getOptionValue,
    isClearable: props.isClearable,
    isDisabled: props.isDisabled,
    isSearchable: props.isSearchable,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    styles: statusToStyles(status),
    onInputChange: props.onInputChange,
    classNames: props.classNames,
    ref: Primitive_option.some(ref(undefined, selectRef)),
    options: options,
    value: match$1.value,
    onChange: match$1.onChange,
    isMulti: false
  });
}

let Single$1 = {
  make: AutocompleteV5$Select$Single
};

let Select = {
  Single: Single$1
};

function AutocompleteV5$AsyncSelect$Single(props) {
  let __status = props.status;
  let __controlShouldRenderValue = props.controlShouldRenderValue;
  let controlShouldRenderValue = __controlShouldRenderValue !== undefined ? __controlShouldRenderValue : true;
  let status = __status !== undefined ? __status : "Neutral";
  let match = useCommonProps({
    getOptionLabel: props.getOptionLabel,
    getOptionValue: props.getOptionValue
  });
  let match$1 = useSingleProps({
    value: props.value,
    onChange: props.onChange
  });
  let loadOptions = useLoadOptions(props.loadOptions);
  return JsxRuntime.jsx(Async, {
    classNamePrefix: "autocomplete",
    components: props.components,
    controlShouldRenderValue: controlShouldRenderValue,
    getOptionLabel: match.getOptionLabel,
    getOptionValue: match.getOptionValue,
    isClearable: props.isClearable,
    noOptionsMessage: Stdlib_Option.map(props.noOptionsMessage, noOptionsMessage),
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    styles: statusToStyles(status),
    defaultOptions: props.defaultOptions,
    loadOptions: loadOptions,
    value: match$1.value,
    onChange: match$1.onChange,
    isMulti: false
  });
}

let Single$2 = {
  make: AutocompleteV5$AsyncSelect$Single
};

let AsyncSelect = {
  Single: Single$2
};

function AutocompleteV5$AsyncGroupSelect$Single(props) {
  let __status = props.status;
  let status = __status !== undefined ? __status : "Neutral";
  let selectRef = React.useRef(undefined);
  let match = useCommonProps({
    getOptionLabel: props.getOptionLabel,
    getOptionValue: props.getOptionValue
  });
  let match$1 = useSingleProps({
    value: props.value,
    onChange: props.onChange
  });
  let loadOptions = useLoadOptionsGroup(props.loadOptions);
  return JsxRuntime.jsx(Async, {
    classNamePrefix: "autocomplete",
    components: props.components,
    controlShouldRenderValue: true,
    getOptionLabel: match.getOptionLabel,
    getOptionValue: match.getOptionValue,
    isClearable: props.isClearable,
    isDisabled: props.isDisabled,
    noOptionsMessage: Stdlib_Option.map(props.noOptionsMessage, noOptionsMessage),
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    styles: statusToStyles(status),
    classNames: props.classNames,
    ref: Primitive_option.some(ref(props.forwardRef, selectRef)),
    loadOptions: loadOptions,
    value: match$1.value,
    onChange: match$1.onChange,
    isMulti: false
  });
}

let Single$3 = {
  make: AutocompleteV5$AsyncGroupSelect$Single
};

function AutocompleteV5$AsyncGroupSelect$Multi(props) {
  let __status = props.status;
  let status = __status !== undefined ? __status : "Neutral";
  let selectRef = React.useRef(undefined);
  let match = useCommonProps({
    getOptionLabel: props.getOptionLabel,
    getOptionValue: props.getOptionValue
  });
  let match$1 = useMultiProps({
    value: props.value,
    onChange: props.onChange
  });
  let loadOptions = useLoadOptionsGroup(props.loadOptions);
  return JsxRuntime.jsx(Async, {
    classNamePrefix: "autocomplete",
    components: props.components,
    controlShouldRenderValue: true,
    getOptionLabel: match.getOptionLabel,
    getOptionValue: match.getOptionValue,
    isClearable: props.isClearable,
    isDisabled: props.isDisabled,
    noOptionsMessage: Stdlib_Option.map(props.noOptionsMessage, noOptionsMessage),
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    styles: statusToStyles(status),
    ref: Primitive_option.some(ref(props.forwardRef, selectRef)),
    loadOptions: loadOptions,
    value: match$1.value,
    onChange: match$1.onChange,
    isMulti: true
  });
}

let Multi$1 = {
  make: AutocompleteV5$AsyncGroupSelect$Multi
};

let AsyncGroupSelect = {
  Single: Single$3,
  Multi: Multi$1
};

let components_Input = ReactSelect.Input.make;

let components = {
  Input: components_Input
};

function AutocompleteV5$AsyncCreatableSelect$Multi(props) {
  let __status = props.status;
  let status = __status !== undefined ? __status : "Neutral";
  let selectRef = React.useRef(undefined);
  let match = useCommonProps({
    getOptionLabel: props.getOptionLabel,
    getOptionValue: props.getOptionValue,
    formatOptionLabel: props.formatOptionLabel
  });
  let match$1 = useCreatableProps({
    getNewOptionData: props.getNewOptionData
  });
  let match$2 = useMultiProps({
    value: props.value,
    onChange: props.onChange
  });
  let loadOptions = useLoadOptions(props.loadOptions);
  return JsxRuntime.jsx(AsyncCreatable, {
    classNamePrefix: "autocomplete",
    components: components,
    controlShouldRenderValue: true,
    formatOptionLabel: match.formatOptionLabel,
    getOptionLabel: match.getOptionLabel,
    getOptionValue: match.getOptionValue,
    isClearable: props.isClearable,
    noOptionsMessage: Stdlib_Option.map(props.noOptionsMessage, noOptionsMessage),
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    placeholder: props.placeholder,
    styles: statusToStyles(status),
    ref: Primitive_option.some(ref(undefined, selectRef)),
    inputId: props.id,
    onPaste: props.onPaste,
    isValidNewOption: props.isValidNewOption,
    getNewOptionData: match$1.getNewOptionData,
    defaultOptions: props.defaultOptions,
    loadOptions: loadOptions,
    value: match$2.value,
    onChange: match$2.onChange,
    isMulti: true
  });
}

let Multi$2 = {
  make: AutocompleteV5$AsyncCreatableSelect$Multi
};

let AsyncCreatableSelect = {
  components: components,
  Multi: Multi$2
};

exports.Styles = Styles;
exports.SelectRef = SelectRef;
exports.Types = Types;
exports.Helpers = Helpers;
exports.OptionsHelpers = OptionsHelpers;
exports.Select = Select;
exports.AsyncSelect = AsyncSelect;
exports.AsyncGroupSelect = AsyncGroupSelect;
exports.AsyncCreatableSelect = AsyncCreatableSelect;
/*  Not a pure module */
